import { Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-collapse-panel",
  templateUrl: "./collapse-panel.component.html",
  styleUrls: ["./collapse-panel.component.scss"],
})
export class CollapsePanelComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
